<template>
  <el-dialog
    title="Criar Diretório"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    append-to-body
    v-loading="isLoading"
    @open="reset"
    width="35%"
  >
    <el-form ref="form" :model="formulario" :rules="validacao" hide-required-asterisk :show-message="false" size="small" label-position="top">
      <el-form-item label="Nome Diretório" prop="nome">
        <el-input v-model="formulario.nome"/>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="validar()" type="primary" size="small" round class="btn-box-shadow">Criar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  props: {
    visibility: Boolean,
    tipo: String
  },

  data() {
    return {
      formulario: {
        nome: "",
      },

      validacao: {
        nome: [{ required: true }],
      },
    };
  },

  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),
    // VENDA
    ...mapState("vendasImoveisStore", {
      imovel(state) { return state.imovelSelecionado; }
    }),
    ...mapState("vendasContratosStore", {
      venda(state) { return state.vendaSelecionada; }
    }),
    // ALUGUEL
    ...mapState("alugueisContratosStore", {
      aluguel(state) { return state.aluguelSelecionado; }
    }),
    ...mapState("alugueisImoveisStore", {
      imovelAluguel(state) { return state.imovelSelecionado; }
    }),
    ...mapState("vendasClientesStore", {
      clienteVenda(state){ return state.clienteSelecionado; }
    }),
    ...mapState("alugueisClientesStore", {
      clienteAluguel(state){ return state.clienteSelecionado; }
    }),
  },

  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    // IMOVEL VENDA
    ...mapActions("vendasImoveisStore", ["criarDiretorioArquivoImovelVenda"]),
    // IMOVEL ALUGUEL
    ...mapActions("alugueisImoveisStore", ["criarDiretorioArquivoImovelAluguel"]),
    // ALUGUEL
    ...mapActions("alugueisContratosStore", ["criarDiretorioArquivoAluguel"]),
    // VENDA
    ...mapActions("vendasContratosStore", ["criarDiretorioArquivoVenda"]),
    // CLIENTE ALUGUEL
        ...mapActions("alugueisClientesStore", ["criarDiretorioArquivoClienteAluguel"]), 
    // CLIENTE VENDA
    ...mapActions("vendasClientesStore", ["criarDiretorioArquivoClienteVenda"]),


    validar() {
      this.$refs.form.validate(isValid => {
        if(!isValid) {
          this.$alert('Preencha Todos os Campos Obrigatórios', 'Atenção', { confirmButtonText: 'OK' });
          return;
        }

        this.criarDiretorio();
      });
    },

    criarDiretorio() {
      switch(this.tipo) {
      case "IMOVEL_VENDA":
        this.requestImovel();
        break;
      case "IMOVEL_ALUGUEL":
        this.requestImovelAluguel();
        break;
      case "ALUGUEL":
        this.requestAluguel();
        break; 
      case "VENDA":
        this.requestVenda();
        break;  
      case "CLIENTE_ALUGUEL":
        this.requestClienteAluguel();
        break;   
      case "CLIENTE_VENDA":
        this.requestClienteVenda();
        break;     
      }
    },
    // IMOVEL VENDA
    requestImovel() {
      let payload = {
        idImovel: this.imovel.id,
        nome: this.formulario.nome
      };

      this.showLoading();
      this.criarDiretorioArquivoImovelVenda(payload)
      .then(resultado => {
        switch (resultado.status) {
        case "SUCESSO":
          this.$message.success(resultado.mensagem);
          this.fechar();
          break;
        case "FALHA":
        case "ERRO":
          this.$message.error(resultado.mensagem);
        }

        this.hideLoading();
      }).catch(() => {
        this.$message.error("Ocorreu um erro.");
        this.hideLoading();
      });
    },
    //IMOVEL ALUGUEL
    requestImovelAluguel() {
      let payload = {
        idImovel: this.imovelAluguel.id,
        nome: this.formulario.nome
      };

      this.showLoading();
      this.criarDiretorioArquivoImovelAluguel(payload)
      .then(resultado => {
        switch (resultado.status) {
        case "SUCESSO":
          this.$message.success(resultado.mensagem);
          this.fechar();
          break;
        case "FALHA":
        case "ERRO":
          this.$message.error(resultado.mensagem);
        }

        this.hideLoading();
      }).catch(() => {
        this.$message.error("Ocorreu um erro.");
        this.hideLoading();
      });
    },
    //ALUGUEL
    requestAluguel() {
      let payload = {
        idAluguel: this.aluguel.id,
        nome: this.formulario.nome
      };

      this.showLoading();
      this.criarDiretorioArquivoAluguel(payload)
      .then(resultado => {
        switch (resultado.status) {
        case "SUCESSO":
          this.$message.success(resultado.mensagem);
          this.fechar();
          break;
        case "FALHA":
        case "ERRO":
          this.$message.error(resultado.mensagem);
        }

        this.hideLoading();
      }).catch(() => {
        this.$message.error("Ocorreu um erro.");
        this.hideLoading();
      });
    },
     //VENDA
    requestVenda() {
      let payload = {
        idVenda: this.venda.id,
        nome: this.formulario.nome
      };

      this.showLoading();
      this.criarDiretorioArquivoVenda(payload)
      .then(resultado => {
        switch (resultado.status) {
        case "SUCESSO":
          this.$message.success(resultado.mensagem);
          this.fechar();
          break;
        case "FALHA":
        case "ERRO":
          this.$message.error(resultado.mensagem);
        }

        this.hideLoading();
      }).catch(() => {
        this.$message.error("Ocorreu um erro.");
        this.hideLoading();
      });
    },
    //CLIENTE ALUGUEL
    requestClienteAluguel() {
      let payload = {
        idCliente: this.clienteAluguel.id,
        nome: this.formulario.nome
      };

      this.showLoading();
      this.criarDiretorioArquivoClienteAluguel(payload)
      .then(resultado => {
        switch (resultado.status) {
        case "SUCESSO":
          this.$message.success(resultado.mensagem);
          this.fechar();
          break;
        case "FALHA":
        case "ERRO":
          this.$message.error(resultado.mensagem);
        }

        this.hideLoading();
      }).catch(() => {
        this.$message.error("Ocorreu um erro.");
        this.hideLoading();
      });
    },
    //CLIENTE VENDA
    requestClienteVenda() {
      let payload = {
        idCliente: this.clienteVenda.id,
        nome: this.formulario.nome
      };

      this.showLoading();
      this.criarDiretorioArquivoClienteVenda(payload)
      .then(resultado => {
        switch (resultado.status) {
        case "SUCESSO":
          this.$message.success(resultado.mensagem);
          this.fechar();
          break;
        case "FALHA":
        case "ERRO":
          this.$message.error(resultado.mensagem);
        }

        this.hideLoading();
      }).catch(() => {
        this.$message.error("Ocorreu um erro.");
        this.hideLoading();
      });
    },
    reset() {
      this.formulario = {
        nome: ""
      };
    },
    fechar() {
      this.$emit("close");
    }
  }
};
</script>

